const themeColors = {
  primary: '#232536',
  secondary: '#ffcf51',
  hover: '#3a3e5a',
}
// attention-grabbing beacon effect
export const createSortButtonStyles = (themeColors) => ({
  position: 'relative',
  backgroundColor: 'rgba(255, 207, 81, 0.08)', // Subtle yellow tint
  animation: 'button-bounce 2s ease-in-out infinite',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '120%', // Reduced from 160%
    height: '120%', // Reduced from 160%
    borderRadius: '50%',
    backgroundColor: themeColors.secondary,
    transform: 'translate(-50%, -50%)',
    animation: 'beacon-pulse 1.5s ease-out infinite',
    zIndex: -1,
    pointerEvents: 'none', // Prevent interfering with clicks
  },
  '@keyframes button-bounce': {
    '0%, 100%': {
      transform: 'scale(1)',
    },
    '25%': {
      transform: 'scale(1.05)',
    },
    '75%': {
      transform: 'scale(1.1)', // Reduced from 1.12
    },
  },
  '@keyframes beacon-pulse': {
    '0%': {
      opacity: 0.5,
      transform: 'translate(-50%, -50%) scale(0.6)',
    },
    '100%': {
      opacity: 0,
      transform: 'translate(-50%, -50%) scale(1.3)', // Reduced from 1.8
    },
  },
})

// alternative more subtle version
export const createSortButtonStylesSubtle = (themeColors) => ({
  position: 'relative',
  backgroundColor: 'rgba(255, 207, 81, 0.05)',
  animation: 'button-gentle-bounce 2.5s ease-in-out infinite',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '110%',
    height: '110%',
    borderRadius: '50%',
    backgroundColor: themeColors.secondary,
    transform: 'translate(-50%, -50%)',
    animation: 'beacon-gentle-pulse 2s ease-out infinite',
    zIndex: -1,
    pointerEvents: 'none',
  },
  '@keyframes button-gentle-bounce': {
    '0%, 100%': {
      transform: 'scale(1)',
    },
    '50%': {
      transform: 'scale(1.05)',
    },
  },
  '@keyframes beacon-gentle-pulse': {
    '0%': {
      opacity: 0.4,
      transform: 'translate(-50%, -50%) scale(0.7)',
    },
    '100%': {
      opacity: 0,
      transform: 'translate(-50%, -50%) scale(1.2)',
    },
  },
})

// alternative dual ring effect (no background glow)
export const createSortButtonStylesDualRing = (themeColors) => ({
  position: 'relative',
  animation: 'button-scale 2s ease-in-out infinite',
  '&::before, &::after': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    borderRadius: '50%',
    zIndex: -1,
    pointerEvents: 'none',
  },
  '&::before': {
    width: '115%',
    height: '115%',
    backgroundColor: 'rgba(255, 207, 81, 0.15)',
    transform: 'translate(-50%, -50%)',
    animation: 'ring-pulse-1 2s ease-in-out infinite',
  },
  '&::after': {
    width: '100%',
    height: '100%',
    border: `2px solid ${themeColors.secondary}`,
    transform: 'translate(-50%, -50%)',
    animation: 'ring-pulse-2 2s ease-in-out infinite',
  },
  '@keyframes button-scale': {
    '0%, 100%': {
      transform: 'scale(1)',
    },
    '50%': {
      transform: 'scale(1.08)',
    },
  },
  '@keyframes ring-pulse-1': {
    '0%, 100%': {
      opacity: 0,
      transform: 'translate(-50%, -50%) scale(0.8)',
    },
    '50%': {
      opacity: 0.3,
      transform: 'translate(-50%, -50%) scale(1.1)',
    },
  },
  '@keyframes ring-pulse-2': {
    '0%': {
      opacity: 1,
      transform: 'translate(-50%, -50%) scale(1)',
    },
    '100%': {
      opacity: 0,
      transform: 'translate(-50%, -50%) scale(1.3)',
    },
  },
})
